import React from 'react'
import {storage} from '../../utils';
import {connect} from 'react-redux';
import '../../styles/classroom/ClassroomQuickListen.css';
import { setEvent } from '../../services';


class ClassroomQuickListen extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            showOwn: true
        }
    }

    componentWillReceiveProps(nextProps) {
        const {showQuickGuide} = nextProps
        if (showQuickGuide) {
            this.quickListenIt = setTimeout(() => {
                this.setState({showOwn: false})
                this.props.dispatch({type: 'CLASSROOM_HIDE_QUICK_GUIDE'})  
            }, 5000)
        }
    }

    componentWillUnmount() {
        this.setState({showOwn: true})
        this.quickListenIt && clearTimeout(this.quickListenIt)
    }

    checkShowQuick() {
        const date = new Date().getDate()
        const month = new Date().getMonth() + 1
        const hasClickQuick = storage.getItem(`wkShowQuickListen`)
        const quickShowNums = storage.getItem(`wkShowQuickListen_nums`)
        const dateQuickShow = storage.getItem(`wkShowQuickListen_${month}${date}`)
        // 如果已经点击去过极简模式 || 显示次数大于3 || 当天显示过，不再显示
        const hideQuick = hasClickQuick || quickShowNums > 2 || dateQuickShow

        // 判定次数
        if (!dateQuickShow && quickShowNums < 4) {
            storage.setItem(`wkShowQuickListen_${month}${date}`, 1)

            if (quickShowNums) {
                storage.setItem(`wkShowQuickListen_nums`, quickShowNums + 1)
            } else {
                storage.setItem(`wkShowQuickListen_nums`, 1)
            }
        }
        return hideQuick
    }

    render() {
        const {showQuickGuide} = this.props
        const {showOwn} = this.state

        if (!showQuickGuide) return null

        const hideQuick = this.checkShowQuick()
        if (hideQuick) return null

        setEvent({ name: 'wk-show-listen-guide' })
        return (
            <div className={`classroom-quick-listen ${!showOwn ? 'classroom-quick-listen__hide' : 'classroom-quick-listen__show'}`}>
                <p className="lecture-guide">
                    <span className="lecture-guide__block">点击这里</span>
                    <span className="lecture-guide__block">听课更专注</span>
                    <span className="lecture-guide__angle"/>
                </p>
            </div>
        )
    }
}

export default connect((state) => ({
    showQuickGuide: state.classroom.showQuickGuide
}))(ClassroomQuickListen)


// WEBPACK FOOTER //
// ./src/components/classroom/ClassroomQuickListen.js